var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({attrs:{"color":_vm.iconColor,"small":_vm.small},domProps:{"innerHTML":_vm._s(_vm.menuIcon)}},on))]}}])},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }